import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Bidding from './Bidding';
import UserConfigurationItem from './UserConfigurationItem';
import { getBiddingUserConfiguration } from '../../reducers';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';

function BiddingItem() {
    const { t } = useTranslation();
    const biddingUserConfiguration = useSelector(getBiddingUserConfiguration);
    return (
        <UserConfigurationItem
            title={<><FontAwesomeIcon icon="gavel" />&nbsp;{t('user-configuration.bidding.title')}</>}
            detailVisibleOnLoad
        >
            <Bidding biddingUserConfiguration={biddingUserConfiguration} />
        </UserConfigurationItem>
    );
}

export default withPrivileges([Privileges.BID_EDIT_ALL, Privileges.BID_EDIT_OWN])(BiddingItem);
